import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./about-growing.scss";

const AboutGrowing = () => {
  return (
    <section className="about-growing">
      <Fade direction="up" duration={800} triggerOnce>
        <IntroSectionBadge
          title={"Crescita e Coinvolgimento Familiare (2005)"}
          text={
            "Nel 2005, nella prospettiva della crescita aziendale, iniziarono a prendere parte all'attività lavorativa i figli del fondatore, fino a giungere a giugno 2015, anno di svolta per l'attività di impresa."
          }
          boxIcon={"primary"}
          icon={"rocket"}
          bgColor={"light"}
        />
      </Fade>
      <Fade
        cascade
        direction="up"
        duration={1000}
        delay={200}
        damping={0.25}
        triggerOnce
      >
        <div className="about-growing__cards-list">
          <IconDescription
            icon={2005}
            title={"Coinvolgimento Familiare"}
            text={
              "I figli del fondatore iniziano a partecipare attivamente all'attività aziendale"
            }
            type={"primary-rounded"}
            size={"medium"}
            direction="vertical"
          />
          <IconDescription
            icon={"increment"}
            title={"Crescita Aziendale"}
            text={
              "Espansione delle attività e consolidamento della presenza sul mercato"
            }
            type={"secondary-rounded"}
            size={"medium"}
            direction="vertical"
          />
          <IconDescription
            icon={2015}
            title={"Anno di Svolta"}
            text={
              "Giugno 2015 segna un momento decisivo per l'evoluzione dell'impresa"
            }
            type={"primary-rounded"}
            size={"medium"}
            direction="vertical"
          />
        </div>
      </Fade>
    </section>
  );
};

export default AboutGrowing;
